import React, { useEffect, useRef, useState } from "react";
import { FaEllipsisH, FaEdit, FaExternalLinkAlt, FaRegCopy, FaTrashAlt } from "react-icons/fa";
import "./adminDashboard.css";

function formatViews(n) {
  try {
    return new Intl.NumberFormat().format(n);
  } catch {
    return String(n);
  }
}

export default function ArticleRow({ article, onAction }) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    const onDocClick = (e) => {
      if (!wrapRef.current) return;
      if (open && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [open]);

  const statusClass = article.status === "published" ? "adminBadgePublished" : "adminBadgeDraft";

  return (
    <tr className="adminRow">
      <td>
        <a className="adminLink" href={`/admin/posts/${article.id}/edit`} onClick={(e) => e.preventDefault()}>
          {article.title}
        </a>
        <div style={{ marginTop: 4, color: "#6b7280", fontSize: 12, fontWeight: 600 }}>{article.author}</div>
      </td>
      <td>{article.author}</td>
      <td>
        <span className={`adminBadge ${statusClass}`}>{article.status}</span>
      </td>
      <td>{formatViews(article.views)}</td>
      <td>{article.date}</td>
      <td style={{ textAlign: "right" }}>
        <div className="adminKebab" ref={wrapRef}>
          <button
            className="adminKebabButton"
            type="button"
            aria-label="Quick actions"
            onClick={() => setOpen((v) => !v)}
          >
            <FaEllipsisH />
          </button>
          {open && (
            <div className="adminMenu" role="menu" aria-label="Article actions">
              <button
                type="button"
                className="adminMenuItem"
                onClick={() => {
                  setOpen(false);
                  onAction?.("edit", article);
                }}
              >
                <FaEdit /> Edit
              </button>
              <button
                type="button"
                className="adminMenuItem"
                onClick={() => {
                  setOpen(false);
                  onAction?.("open", article);
                }}
              >
                <FaExternalLinkAlt /> Open
              </button>
              <button
                type="button"
                className="adminMenuItem"
                onClick={async () => {
                  setOpen(false);
                  try {
                    await navigator.clipboard.writeText(article.title);
                  } catch {
                    // ignore
                  }
                  onAction?.("copy", article);
                }}
              >
                <FaRegCopy /> Copy title
              </button>
              <button
                type="button"
                className="adminMenuItem"
                onClick={() => {
                  setOpen(false);
                  onAction?.("delete", article);
                }}
              >
                <FaTrashAlt /> Delete
              </button>
            </div>
          )}
        </div>
      </td>
    </tr>
  );
}

